import Home from "./Home.svelte";
import "./main.css";
import { AppStore, AppType } from "./stores/AppStore";
AppStore.setType(AppType.DASHBOARD);
const home = new Home({
    target: document.body,
    props: {},
});
export default home;
